import styled from 'styled-components';
import Button from '@carvana/showroom-forms/Button/Primary';
import Checkbox from '@carvana/showroom-forms/Checkbox';

const DisableAutoPayTileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: white;
  padding: 25px 25px 40px;
  border: 1px solid #d9dde9;
  border-radius: 8px;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  margin: 0 auto;
  max-width: 912px;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 325px;
    justify-content: flex-start;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-height: 410px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    min-height: auto;
    padding: 40px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xl}px) {
    min-height: 320px;
  }
`;

const DisableAutopayCheckbox = styled(Checkbox)`
  margin-top: 4px;
`;

const CheckboxWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
`;

const ConfirmButton = styled(Button)`
  flex-grow: 1;
  margin: 25px 0 50px 0;
  min-width: 200px;
  max-width: 250px;
  height: 55px;

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 200px;
    width: 100%;
  }
`;

const LabelWrapper = styled.p`
  color: #6d7184;
  ${(props) => props.theme.font.body.v200};
  max-width: 630px;
  margin: 0;
`;

const DisclaimerWrapper = styled.p`
  padding: 30px 0 0;
  max-width: 630px;
  ${(props) => props.theme.font.body.v200};
  flex-grow: 1;
  color: #6d7184;
  margin: 0;
`;

const Title = styled.h1`
  ${(props) => props.theme.font.heading.v400};
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0 0 30px;
  margin: 0 auto;
  max-width: 912px;
  font-size: 20px;
  line-height: 24px;
`;

const ConsentButton = styled.span`
  color: ${(props) => props.theme.color.primary.v200};
  background: none;
  text-decoration: underline;

  &:hover {
    cursor: pointer;
  }
`;

export {
  DisableAutopayCheckbox,
  DisableAutoPayTileWrapper,
  CheckboxWrapper,
  ConfirmButton,
  LabelWrapper,
  DisclaimerWrapper,
  Title,
  ConsentButton,
};
